import React, { useContext } from 'react';

import LabelName from 'components/UI/LabelName/LabelName';

import { UserDetailsContext } from 'context/userDetailsContext';
import { handleDateTimeOffset } from 'utils/utility_functions/timezone';
import constants from 'constants/index';
import { useConferenceRooms } from 'hooks/useConferenceRooms';
function GooglePreview({ eventDetails }) {
  const userContext = useContext(UserDetailsContext);
  const { conferenceRoomOptions } = useConferenceRooms();

  let conference_url = eventDetails?.conference_url;

  // Function to get conference room name by ID
  const getConferenceRoomName = (roomId) => {
    if (!roomId || !conferenceRoomOptions) return null;
    const room = conferenceRoomOptions.find((room) => room.value === roomId);
    return room?.label || null;
  };

  function navigateTo() {
    let url = btoa(eventDetails?.google_event_id + ' ' + eventDetails?.calendar_id);
    url = url.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return `https://calendar.google.com/calendar/event?eid=${url}`;
  }

  return (
    <form>
      {/* form heading */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="modal-heading F-size16 text-bold">Google Meet</div>
      </div>
      {/* title */}
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12 ">
          <LabelName required={false} htmlFor="title">
            Event Title
          </LabelName>
        </div>
        <div className="col-md-8 col-12 input-style">{eventDetails?.title}</div>
      </div>
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12">
          <LabelName required={false} htmlFor="title">
            Date
          </LabelName>
        </div>
        <div className="col-md-8 col-12 input-style">
          {handleDateTimeOffset(userContext.userDetails.timezone, eventDetails?.meeting_start_time, constants.month_date_year_format)}
        </div>
      </div>
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12">
          <LabelName required={false} htmlFor="title">
            Time
          </LabelName>
        </div>
        <div className="col-md-8 col-12 d-flex gap-3 align-items-center">
          <div className="w-100 input-style">
            {handleDateTimeOffset(userContext.userDetails.timezone, eventDetails?.meeting_start_time, constants.hour_minute_12_format)}
          </div>
          <div className="text-bold">-</div>
          <div className="w-100 input-style">
            {handleDateTimeOffset(userContext.userDetails.timezone, eventDetails?.meeting_end_time, constants.hour_minute_12_format)}
          </div>
        </div>
      </div>
      {eventDetails?.location && (
        <div className="d-flex align-items-center py-2 flex-wrap">
          <div className="col-md-4 col-12 ">
            <LabelName required={false} htmlFor="title">
              Location
            </LabelName>
          </div>
          <div className="col-md-8 col-12 input-style">{eventDetails?.location}</div>
        </div>
      )}
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12 ">
          <LabelName required={false} htmlFor="conference_room">
            Conference Room
          </LabelName>
        </div>
        <div className="col-md-8 col-12 input-style">
          {(() => {
            const roomName =
              eventDetails?.room_name ||
              eventDetails?._conference_room_ ||
              getConferenceRoomName(eventDetails?.conference_room_id) ||
              getConferenceRoomName(eventDetails?.conference_room);
            return roomName || 'None';
          })()}
        </div>
      </div>
      {eventDetails?.guests?.length > 0 && (
        <div className="d-flex align-items-center py-2 flex-wrap">
          <div className="col-md-4 col-12 ">
            <LabelName required={false} htmlFor="title">
              Attendees
            </LabelName>
          </div>
          <div className="col-md-8 col-12">
            {eventDetails?.guests?.map((v, i) => {
              return (
                <div className="input-style mb-2 text-break" key={i}>
                  {v?.email}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {eventDetails?.description && (
        <div className="d-flex align-items-center py-2 flex-wrap">
          <div className="col-md-4 col-12 ">
            <LabelName required={false} htmlFor="title">
              Description
            </LabelName>
          </div>
          <div className="col-md-8 col-12 input-style">{eventDetails?.description}</div>
        </div>
      )}
      {conference_url && (
        <div className="d-flex align-items-center py-2 flex-wrap">
          <div className="col-md-4 col-12">
            <LabelName required={false} htmlFor="title">
              Meet link
            </LabelName>
          </div>
          <div className="col-md-8 col-12 d-flex gap-3 align-content-center">
            <a className="btn btn-primary" href={conference_url} target="_blank" rel="noopener noreferrer">
              Join With Google Meet
            </a>
          </div>
        </div>
      )}
      <div className="d-flex align-items-center py-2 flex-wrap">
        <div className="col-md-4 col-12">
          <LabelName required={false} htmlFor="title">
            {/* Calendar link */}
          </LabelName>
        </div>
        <div className="col-md-8 col-12 d-flex gap-3 align-content-center">
          <a
            href={navigateTo()} // Set the actual href for right-click and `Ctrl+Click`
            target="_blank" // Ensure the link opens in a new tab
            rel="noopener noreferrer" // Security measure for opening in a new tab
            onClick={(e) => {
              // Prevent default action on regular left-click
              e.preventDefault();

              // Open the external URL manually for left-click
              window.open(navigateTo(), '_blank');
            }}
          >
            More Details
          </a>
        </div>
      </div>
    </form>
  );
}

export default GooglePreview;
